export default __webpack_public_path__ + "static/whistler-canada-d50d4bccfb9378c5967f5ff9187d0e26.jpg";